import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines multiple class values into a single string, merging Tailwind classes.
 * Null-safe utility function.
 */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}

/**
 * Type guard to check if a value is not null or undefined
 */
export function isNonNull<T>(value: T | null | undefined): value is T {
	return value !== null && value !== undefined;
}

/**
 * Safely access an object property with null check
 */
export function safeGet<T, K extends keyof T>(
	obj: T | null | undefined,
	key: K,
): T[K] | undefined {
	return obj?.[key];
}

/**
 * Format a phone number for display
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
	if (!phone) return "";
	return phone.replace(/(\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
}

/**
 * Validate email address
 */
export function isValidEmail(email: string): boolean {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/**
 * Sanitize string input
 */
export function sanitizeInput(input: string | null | undefined): string {
	if (!input) return "";
	return input.trim().replace(/[<>]/g, "");
}
